<template>
    
    <div>
        
        <v-card outlined tile v-for="reporter in reporters" :key="reporter.id" @click="selectAction(reporter)">

            <div class="d-flex pa-2 align-center">

                {{reporter.name}}

                <v-spacer></v-spacer>

                <v-icon :color="statusColor(reporter.status)">mdi-cloud</v-icon>

                <v-btn icon>
                    <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
                
            </div> 

        </v-card>

    </div>

</template>

<script>

import { mapGetters } from "vuex" ;
// import reportersApi from "@/api/reporters/Reporters" ;

export default {

    name: "Reporters",
    computed: {
        // map `this.user` to `this.$store.getters.user`
        ...mapGetters({
            currentCompany: "companies/currentCompany",
            reporters: "reporters/reporters",
            devices: "reporters/devices",
        })
    },
    props: {
        action: {
            type: String,
            required: false,
            default: 'toDevice'
        },
    },
    created() {

        // if(this.reporters === null){

        //     let api = new reportersApi() ;

        //     api.get().then(data => {
        //         this.reporters = data ;
        //     })

        // }
        
    },
    methods: {
        
        selectAction(reporter){

             let data = {
                name: 'reporter',
                value: reporter
            }

            this.$store.commit('app/setSelected', data);

            let devices = this.getDevices(reporter.id) ;

            data = {
                name: 'device',
                value: devices[0]
            }

            this.$store.commit('app/setSelected', data);

            if(this.action != 'select'){

                this.getReporterLink(reporter);
               

            }
            // else{

            //     let data = {
            //         name: 'reporter',
            //         value: reporter
            //     }

            //     this.$store.commit('app/setSelected', data);

            //     let devices = this.getDevices(reporter.id) ;

            //     data = {
            //         name: 'device',
            //         value: devices[0]
            //     }

            //     this.$store.commit('app/setSelected', data);


                
            // }

        },
        statusColor(status){

            if(status == 'active'){
                return 'green';
            }else if(status == 'ping'){
                return 'orange';
            }else if(status == 'offline'){
                return 'red';
            }else{
                return 'grey';
            }

        },
        getDevices(reporter_id){

            return this.devices.filter(function( obj ) {
                return obj.reporter_id === reporter_id ;
            });

        },
        getReporterLink(reporter){

            let devices = this.getDevices(reporter.id) ;

            // console.log('devices');
            // console.log(devices);
            // console.log(devices.length);

            if(devices.length == 1){
                this.$router.push('/device/'+devices[0].id);
            }else if(devices.length < 1){
                this.$router.push('/reporters');
            }else{
                this.$router.push('/reporters/'+reporter.id);
            }

        }
        
    }

};

</script>